import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { usePopoverHandlers } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS, } from '@as-react/common-types';
import { axiosClient } from '@as-react/common-utils';
import { InfoIcon } from '@yonderland/andes-icons';
import { IconButton } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { analyticsActions } from '../../../../redux/analytics/actions/AnalyticsActions.creators';
import { makeGetStoreId, makeGetUrlInformationSearch } from '../../../../redux/url/selectors/UrlSelectors';
import { FilterWizardModal } from './FilterWizardModal';
export const FilterWizard = ({ filter, filterWizardPath, initialItemsCount, updateFilters, urlFilters, }) => {
    const { mainWebShop, lang: locale, languageAnalytics: anaLang, fictiveWebShop, fredHopperSearchUrl, isShopLanding, } = useAemConfig();
    const [data, setData] = useState(null);
    const [itemsCount, setItemsCount] = useState(initialItemsCount);
    const [showFilterWizard, setShowFilterWizard] = useState(false);
    const [activeWizardFilterKeys, setActiveWizardFilterKeys] = useState([]);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({
        close: () => setShowFilterWizard(false),
    });
    const dispatch = useDispatch();
    const searchQuery = useSelector(makeGetUrlInformationSearch());
    const activeStoreId = useSelector(makeGetStoreId());
    const loadFilterWizardData = () => __awaiter(void 0, void 0, void 0, function* () {
        const axiosConfig = {
            method: 'GET',
            url: `${filterWizardPath}.model.${filter.filterOn}.json`,
            withCredentials: true,
        };
        try {
            const response = yield axiosClient.request(axiosConfig);
            return response.data;
        }
        catch (_a) {
            return null;
        }
    });
    const fetchSearchResultsCount = (tmpFilter) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const axiosConfig = {
                method: 'GET',
                params: {
                    anaLang,
                    fictiveWebShop,
                    locale,
                    mainWebShop,
                    query: searchQuery,
                    storeId: activeStoreId,
                    platform: isShopLanding
                        ? PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.shoplanding
                        : PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.public_site,
                },
                url: `${fredHopperSearchUrl}?${tmpFilter}`,
                withCredentials: true,
            };
            const response = yield axiosClient.request(axiosConfig);
            setItemsCount(response.data.itemCount);
        }
        catch (_a) { }
    });
    const openFilterWizard = () => __awaiter(void 0, void 0, void 0, function* () {
        const filterWizardData = yield loadFilterWizardData();
        if (filterWizardData) {
            setData(filterWizardData);
        }
    });
    useEffect(() => {
        if (data) {
            handlePopoverOpen(null, null, true);
            dispatch(analyticsActions.filterWizardOpened(filter.filterOn));
            setShowFilterWizard(true);
        }
    }, [data]);
    useEffect(() => {
        if (initialItemsCount !== itemsCount) {
            setItemsCount(initialItemsCount);
        }
    }, [initialItemsCount]);
    useEffect(() => {
        const activeFilterValuesKeys = filter.values.filter(value => value.active).map(value => value.filterKey);
        setActiveWizardFilterKeys(activeFilterValuesKeys);
    }, [filter]);
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: openFilterWizard, variant: "plain", size: "sm", icon: { source: InfoIcon, size: 'xs', color: 'active' }, testId: "filter-wizard" }), !!data && showFilterWizard && (_jsx(FilterWizardModal, { anchorEl: anchorEl, filter: filter, filterWizardDescription: data.description, filterWizardImage: data.image, filterWizardTitle: data.title, filterWizardValues: data.values, itemsCount: itemsCount, handlePopoverClose: handlePopoverClose, fetchSearchResultsCount: fetchSearchResultsCount, updateFilters: updateFilters, urlFilters: urlFilters, activeWizardFilterKeys: activeWizardFilterKeys, setActiveWizardFilterKeys: setActiveWizardFilterKeys }))] }));
};
